import { render } from "./FAQEnView.vue?vue&type=template&id=b2d0348c&scoped=true&ts=true"
import script from "./FAQEnView.vue?vue&type=script&lang=ts"
export * from "./FAQEnView.vue?vue&type=script&lang=ts"

import "./FAQEnView.vue?vue&type=style&index=0&id=b2d0348c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d0348c"]])

export default __exports__